<template>
  <!-- eslint-disable vue/max-attributes-per-line -->
  <div class="d-flex align-center flex-wrap pa-3 gap-2">
    <span class="text--secondary text-body-2 mr-2">
      Всего: <strong>{{ meta.count }}</strong>
      &nbsp;&middot;&nbsp;
      стр. <strong>{{ meta.current_page }}</strong> из <strong>{{ meta.num_pages }}</strong>
    </span>
    <v-pagination
      v-model="localPage"
      :length="meta.num_pages"
      :disabled="loading"
      :total-visible="7"
      class="mr-2"
      @input="onPageInput"
    />
    <v-select
      v-model="localPageSize"
      :items="pageSizeOptions"
      dense
      hide-details
      outlined
      style="max-width: 90px"
      class="text-body-2"
      @change="onPageSizeChange"
    />
  </div>
</template>

<script>
export default {
  name: 'BenefitsPaginator',
  props: {
    meta: {
      type: Object,
      default: () => ({ count: 0, num_pages: 0, current_page: 1 }),
    },
    page: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 20,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pageSizeOptions: [20, 50, 100],
      localPage: this.page,
      localPageSize: this.pageSize,
    }
  },
  watch: {
    page(val) {
      this.localPage = val
    },
    pageSize(val) {
      this.localPageSize = val
    },
  },
  methods: {
    onPageInput(val) {
      this.$emit('page', Number(val) || 1)
    },
    onPageSizeChange(val) {
      this.$emit('page-size', Number(val) || 20)
    },
  },
}
</script>
